module.exports = __webpack_public_path__ + "img/ff9ebead9202e29dc87fe07e212b373b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/blank.png
// module id = 793
// module chunks = 0